import angular from 'angular';
import MenuDropdownComponent from './menu-dropdown.component';

let MenuDropdownModule = angular.module('shared.components.menuDropdown', [])
  .component('menuDropdown', MenuDropdownComponent);

export default MenuDropdownModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/menu-dropdown/menu-dropdown.js
 **/